import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreAgentConversationTitlesReducers } from './titles';
import { getCoreAgentConversationsSlice } from './get';

import { coreAgentConversationChunksReducers, coreAgentConversationChunksWatchers } from './chunks';
import { coreAgentConversationHeaderReducers, coreAgentConversationHeaderWatchers } from './header';
import { coreAgentConversationSearchReducers, coreAgentConversationSearchWatchers } from './search';
import { coreRecentAgentConversationsReducers, coreRecentAgentConversationsWatchers } from './recent';

export const coreAgentConversationsReducers = combineReducers({
	chunks: coreAgentConversationChunksReducers,
	get: getCoreAgentConversationsSlice.asyncReducers,
	header: coreAgentConversationHeaderReducers,
	recent: coreRecentAgentConversationsReducers,
	search: coreAgentConversationSearchReducers,
	titles: coreAgentConversationTitlesReducers
});

export const coreAgentConversationsWatchers = combineAllWatchers([
	coreAgentConversationChunksWatchers,
	getCoreAgentConversationsSlice.asyncWatchers,
	coreAgentConversationHeaderWatchers,
	coreRecentAgentConversationsWatchers,
	coreAgentConversationSearchWatchers
]);
